import { render } from "./warningCount.vue?vue&type=template&id=95a94058&scoped=true"
import script from "./warningCount.vue?vue&type=script&lang=js"
export * from "./warningCount.vue?vue&type=script&lang=js"

import "./warningCount.vue?vue&type=style&index=0&id=95a94058&scoped=true&lang=less"

import exportComponent from "D:\\web\\my\\水茶花\\sch-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95a94058"]])

export default __exports__